import { useCallback, useMemo } from 'react'

import { Button } from 'core-components/library/button'
import { Checkbox } from 'core-components/library/checkbox'
import {
  AbsolutePopup,
  PopPaper,
  TPopupVertical,
  TVisibilityTrigger,
} from 'core-components/library/popup'

import { ROW_ACTIONS_FIELD, ROW_ACTIONS_TITLE } from '../constants/actions'
import { cloneData } from '../helpers/cloneData'
import { setColumnsToStorage } from '../helpers/columnStorageHelper'

import { IColumn, TTitleRenderFunction } from './types'

import styles from './ColumnsFilter.module.scss'

interface IColumnsFilter {
  columns: IColumn[]
  columnsFilterKey?: string
  setColumns: (columns: IColumn[]) => void
  titleRender?: TTitleRenderFunction
}

export const ColumnsFilter = ({
  columns,
  columnsFilterKey,
  setColumns,
  titleRender,
}: IColumnsFilter) => {
  const changeColumns = (value: boolean, field: string) => {
    const newColumns: IColumn[] = cloneData(columns)
    const columnId = newColumns.findIndex((el) => el.field === field)
    if (columnId !== -1) {
      newColumns[columnId].hidden = !value
    }
    setColumns(newColumns)
  }

  const eventsCallback = useMemo(() => {
    return {
      onClose: () => setColumnsToStorage(columnsFilterKey, columns),
    }
  }, [columns, columnsFilterKey])

  const getColumnTitle = useCallback(
    (item: IColumn) => {
      if (item.field === ROW_ACTIONS_FIELD) {
        return ROW_ACTIONS_TITLE
      }
      return (titleRender && titleRender('columnsFilter', item.title)) || item.title
    },
    [titleRender]
  )

  return (
    <AbsolutePopup
      verticalDirection={TPopupVertical.Top}
      verticalStartPosition={TPopupVertical.Top}
      eventCallbacks={eventsCallback}
      popupContent={() => (
        <PopPaper className={styles.popPaper}>
          {columns.map((item) => (
            <Checkbox
              key={item.field}
              label={getColumnTitle(item)}
              padding
              onChange={(value) => {
                changeColumns(value, item.field)
              }}
              checked={!item.hidden}
            />
          ))}
        </PopPaper>
      )}
    >
      <Button
        variant={'text'}
        iconButton={'kbase kbase-settings'}
        __testId={'table__columnVisibilityOptions'}
      />
    </AbsolutePopup>
  )
}
